const state = {
    uploadAttachmentUrl:`${process.env.BASE_API_URL}/api/attachment/upload`,
    importHospitalUrl:`${process.env.BASE_API_URL}/api/import/hospital`,
    templatePath:'/static/template/',
    location_Provices: [],
    location_Citys: [],
    flow_category: "全部",
    user:{},
    validateResult:false,
    flowtype: [],
    queryflowtype:[],
    productParentList: [],
    productParentLineList:[],

    Global_Config: [],
    hosipitals: {},

    BU: {},
    Region: [],
    Product_Line: []
};
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js